/** First DNS label when hostname is `{tenant}.localhost` or `{tenant}.example.com`. */
const RESERVED_APP_HOST_LABELS = new Set([
  'www',
  'app',
  'api',
  'provider',
  'sensemaker',
])

export function getSubdomainFromHostname(hostname: string): string | null {
  const parts = hostname.split('.')
  if (parts.length < 2) return null
  const first = parts[0]?.toLowerCase()
  if (!first || first === 'localhost' || RESERVED_APP_HOST_LABELS.has(first)) {
    return null
  }
  return first
}

